export function appIsEmbedded () {
    return window.self !== window.top;
}